import React, { useState, useEffect, useContext } from 'react';
import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
} from '@windmill/react-ui';
import { Tabs, Tab } from '@mui/material';
import DataWrapper from './DataWrapper';
import Somethingwentwrong from 'pages/Somethingwentwrong';

import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useFilter from 'hooks/useFilter';
import PaymentDetailsServices from 'services/PaymentDetailsServices';
import { SidebarContext } from 'context/SidebarContext';
import sidebar from 'routes/sidebar';
import PaymentDetailsTable from 'components/paymentDetails/PaymentDetailsTable';

const PaymentDetails = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const [loading, setLoading] = useState(false);
	const { isUpdate, setIsUpdate } = useContext(SidebarContext);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const [tab, setTab] = useState(0);
	const [paymentdetailsData, setPaymentDetailsData] = useState([]);
	const [error, setError] = useState(false);
	const [status, setStatus] = useState(false);

	const {
		paymentdetailsRef,
		dataTable,
		serviceData,
		handleSubmitPaymentDetails,
		currentPage,
	} = useFilter(paymentdetailsData, itemsPerPage);

	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		const fetchPaymentDetails = async () => {
			setLoading(true);
			try {
				let response;
				if (tab === 0) {
					response = await PaymentDetailsServices.paymentDetailsList(1);
				} else if (tab === 1) {
					response = await PaymentDetailsServices.paymentDetailsList(2);
				}
				const updatedData =
					response?.data?.map(
						({
							id,
							order_id,
							agent_id,
							ref_no,
							agent_ref_no,
							payment_id,
							amount,
							invoice_number,
							id_client,
							is_recharge,
							transaction_status,
							payment_status,
							current_balance,
							added_date,
							payment_type,
							...rest
						}) => ({
							id,
							order_id,
							ref_no,
							agent_ref_no,
							agent_id,
							payment_id,
							amount,
							invoice_number,
							id_client,
							is_recharge,
							transaction_status,
							payment_status,
							current_balance,
							added_date,
							payment_type,
							...rest,
						})
					) || [];
				setPaymentDetailsData(updatedData);
				setStatus(response?.status);
			} catch (error) {
				setError(true);
				console.error('Error fetching paymentdetails:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchPaymentDetails();

		setIsUpdate(false);
		// eslint-disable-next-line
	}, [tab, isUpdate]);

	const handleTabChange = (_event, newValue) => {
		setTab(newValue);
	};

	// const hideView = adminInfo?.permission?.some(
	//   (perm) => perm.id_tab === "payment details" && perm.view === 1
	// );
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'payment details' && perm.view === 1
		  );

	return (
		<>
			{hideView && (
				<>
					<PageTitle sidebar={sidebar().sidebar} />
					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
						<CardBody>
							<div className="flex flex-wrap items-center gap-3"></div>
							<div style={{ width: '600px' }}>
								<Input
									ref={paymentdetailsRef}
									className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
									type="search"
									name="search"
									placeholder="Quick Search"
									autoComplete="off"
									onChange={handleSubmitPaymentDetails}
								/>
							</div>
						</CardBody>
					</Card>
					<Tabs
						value={tab}
						onChange={handleTabChange}
						TabIndicatorProps={{ style: { backgroundColor: '#057a55' } }}
						sx={{ '& .MuiTab-root': { textTransform: 'capitalize' } }}
					>
						<Tab
							className="focus:outline-none dark:text-gray-300"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Razorpay"
						/>
						<Tab
							className="focus:outline-none dark:text-gray-300"
							sx={{ '&.Mui-selected': { color: '#057a55', outline: 'none' } }}
							label="Wallet"
						/>
					</Tabs>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '65vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="capitalize text-center sticky top-0 z-10 text-sm">
											<tr>
												<TableCell>Sl.No.</TableCell>
												<TableCell>Agent Ref No.</TableCell>
												<TableCell>Client Ref No.</TableCell>
												<TableCell>Customer Name </TableCell>
												<TableCell>Order ID</TableCell>
												<TableCell>Payment ID</TableCell>
												<TableCell>Amount</TableCell>
												<TableCell>Invoice No.</TableCell>
												<TableCell>Is recharge</TableCell>
												<TableCell>Transction Status </TableCell>
												<TableCell>Payment Status</TableCell>
												<TableCell>Current Balance</TableCell>
												<TableCell>Previous Balance</TableCell>
												<TableCell>Date</TableCell>
												{tab !== 1 && <TableCell>View</TableCell>}
											</tr>
										</TableHeader>
										<PaymentDetailsTable
											paymentdetails={dataTable}
											idpayment={paymentdetailsData.payment_id}
											perpage={itemsPerPage}
											currentPage={currentPage}
											tab={tab}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Payment Details." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default PaymentDetails;
